import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import React from "react";

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  // What is searched, for a screen reader ("Search programme links")
  label: string;
}

/**
 * The search above a table of a detail view, at the right end of the line
 * of its filters.
 */
const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, label }) => (
  <TextField
    size="small"
    placeholder="Search"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    inputProps={{ "aria-label": label }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      ),
    }}
    sx={{ ml: "auto", minWidth: 180, "& .MuiInputBase-input": { py: 0.5 } }}
  />
);

export default SearchField;
